require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-tags-aaron-alsup.json") })
        }
      }, "path---articles-tags-aaron-alsup");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-tags-aaron-alsup!./.cache/json/articles-tags-aaron-alsup.json
// module id = 641
// module chunks = 231608221292675